(() => {
  function readCurrentVariant(picker) {
    const json = picker.querySelector(
      'script[type="application/json"]'
    );

    if (!json) return null;

    try {
      return JSON.parse(json.textContent);
    } catch {
      return null;
    }
  }

  function syncVariantImageAltText() {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      const variant = readCurrentVariant(picker);

      const altText =
        variant?.featured_media?.alt ||
        variant?.featured_image?.alt ||
        '';

      const mediaId = variant?.featured_media?.id
        ? String(variant.featured_media.id)
        : '';

      const imageUrl =
        variant?.featured_media?.preview_image?.src ||
        variant?.featured_image?.src ||
        '';

      const fileName =
        imageUrl.split('/').pop()?.split('?')[0] || '';

      if (!altText) return;

      document.querySelectorAll('media-gallery img').forEach((image) => {
        const displayedMediaId =
          image
            .closest('[data-media-id]')
            ?.getAttribute('data-media-id') || '';

        const displayedImageUrl =
          image.currentSrc || image.src || '';

        const sameMedia =
          mediaId && displayedMediaId === mediaId;

        const sameImage =
          fileName && displayedImageUrl.includes(fileName);

        if (sameMedia || sameImage) {
          image.alt = altText;
        }
      });
    });
  }

  let syncTimer;

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncVariantImageAltText, 75);
  }

  function initializeAltTextSync() {
    const productArea = document.querySelector('main');

    if (!productArea) return;

    document.addEventListener('change', scheduleSync, true);

    document.addEventListener(
      'click',
      (event) => {
        if (
          event.target instanceof Element &&
          event.target.closest('.globo-swatch-product-detail')
        ) {
          scheduleSync();
        }
      },
      true
    );

    const observer = new MutationObserver(scheduleSync);

    observer.observe(productArea, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-media-id']
    });

    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAltTextSync,
      { once: true }
    );
  } else {
    initializeAltTextSync();
  }
})();